<template>
  <div id="top-header">
    <div class="center-title">
      朵云产业链系统
    </div>
  </div>
</template>

<script>
export default {
  name: "TopHeader",
  methods: {
    toExternalLink() {
      window.location.href = 'https://datav.aliyun.com/share/5e1528b31f3378bc2a49622c56fae366'
    }
  }
};
</script>

<style lang="scss">
#top-header {
  position: relative;
  width: 100%;
  height: 184px;
  display: flex;
  justify-content: center;
  flex-shrink: 0;
  background: url(../assets/imgs/bg_title.png) no-repeat;
  background-position: center top;
  background-size: 100% auto;
  z-index: 2;
  .center-title {
    position: absolute;
    left: 50%;
    top: 24px;
    width: 450px;
    transform: translateX(-50%);
    .title-img {
      width: 100%;
    }
    color: #fff;
    font-size: 36px;
    text-align: center;
    line-height: 46px;
    letter-spacing: 4px;
  }
}
</style>
